<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <form class="needs-validation" novalidate>
          <div class="password-field-group">
            <label for="email">Вкажіть пошту</label>
            <div class="password-input-wrapper">
              <input
                id="email"
                v-model="form.email"
                type="email"
                :class="['password-input', { 'has-error': errors?.email }]"
                placeholder="Введіть пошту"
              >
            </div>
            <div class="error-message" v-if="errors?.email">{{ errors.email[0] }}</div>
          </div>

          <div class="password-field-group">
            <label for="password">Новий пароль</label>
            <div class="password-input-wrapper">
              <input
                id="password"
                v-model="form.new_password"
                :type="types.new_password"
                :class="['password-input', { 'has-error': errors?.new_password }]"
                placeholder="Введіть новий пароль"
              >
              <button type="button" @click="switchType('new_password')" class="password-toggle-btn">
                <i :class="types.new_password === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
              </button>
            </div>
            <div class="error-message" v-if="errors?.new_password">{{ errors.new_password[0] }}</div>
          </div>

          <div class="password-field-group">
            <label for="new_password_confirmation">Підтвердження нового паролю</label>
            <div class="password-input-wrapper">
              <input
                id="new_password_confirmation"
                v-model="form.new_password_confirmation"
                :type="types.new_password_confirmation"
                :class="['password-input', { 'has-error': errors?.new_password_confirmation }]"
                placeholder="Підтвердіть новий пароль"
              >
              <button type="button" @click="switchType('new_password_confirmation')" class="password-toggle-btn">
                <i :class="types.new_password_confirmation === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
              </button>
            </div>
            <div class="error-message" v-if="errors?.new_password_confirmation">
              {{ errors.new_password_confirmation[0] }}
            </div>
          </div>

          <hr>
          <button :disabled="loading" type="button" @click="saveEmail" class="btn btn-primary">
            <span v-show="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ loading ? "Змінюємо" : "Змінити" }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      types: {
        'new_password': 'password',
        'new_password_confirmation': 'password',
      },
      form: {
        'email': '',
        'new_password': '',
        'new_password_confirmation': '',
      },
      loading: false,
      errors: {},
    }
  },
  methods: {
    switchType(field) {
      this.types[field] = this.types[field] === "password" ? "text" : "password";
    },
    saveEmail(v) {
      this.loading = true;
      this.errors = {};
      axios.post('/user/email/change', this.form)
          .then(response => response.data)
          .then((response) => {
            this.loading = false;
            if (response.success) {
              this.$store.commit('auth/SET_USER', response.user)
              location.reload();
            } else {
              this.$toast.error(response.message)
            }
          }).catch(error => {
        if (error.response.status === 422) {
          this.errors = error.response.data.errors
        } else {
          this.$toast.error('Щось пішло не так =(')
        }
        this.loading = false;
      })
    }
  },
  name: "update-profile"
}
</script>

<style scoped>
.password-field-group {
  margin-bottom: 1.5rem;
}

.password-field-group label {
  display: block;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #495057;
  font-size: 0.9rem;
}

.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: stretch;
}

.password-input {
  flex: 1;
  width: 100%;
  padding: 0.5rem 3rem 0.5rem 0.75rem;
  font-size: 0.9rem;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.password-input:focus {
  border-color: #ff182d;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(255, 24, 45, 0.15);
}

.password-input.has-error {
  border-color: #dc3545;
}

.password-input.has-error:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.15);
}

.password-toggle-btn {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 2.5rem;
  background: transparent;
  border: none;
  color: #6c757d;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.15s ease-in-out;
  z-index: 3;
}

.password-toggle-btn:hover {
  color: #ff182d;
}

.password-toggle-btn:focus {
  outline: none;
}

.error-message {
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: #dc3545;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.error-message::before {
  content: "⚠";
  font-weight: bold;
}

.btn-primary {
  background-color: #ff182d;
  border-color: #ff182d;
  font-weight: 500;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
}

.btn-primary:hover {
  background-color: #d61527;
  border-color: #c01323;
}

</style>
